import React from "react";
import styles from "./StaffTimeTable.module.css";
import { FaListUl, FaFolder, FaClock } from "react-icons/fa";

const colorPalette = ["#a8d5a2", "#c5c9f9", "#f9c5c5", "#d4d4a3", "#a2d5a4"];

const StaffTimeTable = ({ subject, topic, time }) => {
  const backgroundColor =
    colorPalette[Math.floor(Math.random() * colorPalette.length)];

  return (
    <div className={styles.card} style={{ backgroundColor }}>
      <div className={styles.row}>
        <FaListUl className={styles.icon} />
        <span>{subject}</span>
      </div>
      <div className={styles.row}>
        <FaFolder className={styles.icon} />
        <span>{topic}</span>
      </div>
      <div className={styles.row}>
        <FaClock className={styles.icon} />
        <span>{time}</span>
      </div>
    </div>
  );
};

export default StaffTimeTable;
